import { useEffect, useRef } from "react";
function useMoveDomElementWhenScrolling(block, computeTopPosition) {
  var movableHeader = useRef();
  var lastScrollTop = useRef();
  useEffect(function () {
    if (!movableHeader.current || !movableHeader.current) return;
    if (block) {
      movableHeader.current.transition = "none";
      movableHeader.current.style.top = computeTopPosition() + "px";
      //reset transition
      document.removeEventListener("scroll", trackScrolling);
      return;
    }
    document.addEventListener("scroll", trackScrolling);
    return function () {
      document.removeEventListener("scroll", trackScrolling);
    };
  }, [lastScrollTop.current, movableHeader.current, block]);
  var trackScrolling = function trackScrolling() {
    //if (!movableHeader.current || !lastScrollTop.current) return;
    if (document.documentElement.scrollTop > lastScrollTop.current) {
      movableHeader.current.style.top = computeTopPosition() + 'px';
    } else {
      if (movableHeader.current) movableHeader.current.style.top = "0" + "px";
    }
    lastScrollTop.current = document.documentElement.scrollTop;
  };
  return {
    movableHeader: movableHeader,
    lastScrollTop: lastScrollTop
  };
}
export default useMoveDomElementWhenScrolling;